// extracted by mini-css-extract-plugin
module.exports = {"item":"Item__item--3nsyN","expanded":"Item__expanded--32XYa"};